/**
 * Shared rules for when Vite Supabase client env should be treated as unconfigured.
 * Kept pure + exported for unit tests (see tests/unit/supabaseEnvPlaceholder.test.ts).
 */
export function isSupabaseClientEnvPlaceholder(url: string, key: string): boolean {
  const u = url.trim();
  const k = key.trim();
  if (!u || !k) return true;
  if (u.includes('placeholder') || k.includes('placeholder')) return true;
  // Unreplaced copies of .env.example — not a real project
  if (/xxxxx\.supabase\.co/i.test(u)) return true;
  if (k.startsWith('eyJxxx')) return true;
  return false;
}
